import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccounthomeComponent } from './accounthome.component';
import { AppfilesComponent } from './components/appfiles/appfiles.component';
import { UpdatepasswordComponent } from './components/updatepassword/updatepassword.component';

const routes: Routes = [
  {
    path: '',
    component: AccounthomeComponent,
    children: [
      {
        path: 'password',
        component: UpdatepasswordComponent
      },
      {
        path: 'appfiles',
        component: AppfilesComponent
      }
    ]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountmanagementRoutingModule { }
